import React from 'react';
import { User, Users, Calendar, Bot, Clock } from 'lucide-react';

type TabType = 'profile' | 'team' | 'integrations' | 'automations' | 'ai';

interface TabNavigationProps {
  activeTab: TabType;
  setActiveTab: React.Dispatch<React.SetStateAction<TabType>>;
  hasTeams: boolean;
}

const tabs: { id: TabType; label: string; shortLabel: string; icon: React.ElementType; teamOnly?: boolean }[] = [
  { id: 'ai', label: 'AI', shortLabel: 'AI', icon: Bot },
  { id: 'profile', label: 'Profile & Preferences', shortLabel: 'Profile', icon: User },
  { id: 'team', label: 'Team Settings', shortLabel: 'Team', icon: Users, teamOnly: true },
  { id: 'integrations', label: 'Integrations', shortLabel: 'Integrate', icon: Calendar },
  { id: 'automations', label: 'Automations', shortLabel: 'Automate', icon: Clock },
];

export const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  setActiveTab,
  hasTeams,
}) => {
  const visibleTabs = tabs.filter(t => !t.teamOnly || hasTeams);

  return (
    <div className="border-b border-gray-200 dark:border-gray-700 -mx-4 px-4 sm:mx-0 sm:px-0">
      <nav className="flex overflow-x-auto scrollbar-hide gap-1 sm:gap-0 sm:space-x-6">
        {visibleTabs.map(({ id, label, shortLabel, icon: Icon }) => {
          const isActive = activeTab === id;
          return (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              className={`flex items-center gap-1.5 py-2.5 px-2.5 sm:px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap flex-shrink-0 ${
                isActive
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
              }`}
            >
              <Icon className="w-4 h-4" />
              <span className="hidden sm:inline">{label}</span>
              <span className="sm:hidden">{shortLabel}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};
